"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.primitives = exports.transition = exports.borderRadius = exports.shadow = exports.breakpoint = exports.lineHeight = exports.fontWeight = exports.fontSize = exports.fontFamily = exports.space = exports.color = void 0;
var index_json_1 = __importDefault(require("./index.json"));
exports.color = index_json_1.default.color;
exports.space = index_json_1.default.space;
exports.fontFamily = index_json_1.default.fontFamily;
exports.fontSize = index_json_1.default.fontSize;
exports.fontWeight = index_json_1.default.fontWeight;
exports.lineHeight = index_json_1.default.lineHeight;
exports.breakpoint = index_json_1.default.breakpoint;
exports.shadow = index_json_1.default.shadow;
exports.borderRadius = index_json_1.default.borderRadius;
exports.transition = index_json_1.default.transition;
exports.primitives = index_json_1.default;
exports.default = index_json_1.default;
